import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../store/ducks/estoque/actions';
import { ApplicationState } from '../../../../store';
import { Card, List } from 'antd';
import CardSecMobile from '../CardSecMobile';

import { RowLine, SpanBlock } from './styles';

const CardMobile: React.FC<any> = ({ props, loading, inscricaoAtiva, cddAtivo, filter }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const pagination = useSelector((state: ApplicationState) => state.Estoque.pagination);

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.codReferencia}>
            <RowLine>
              <p>
                <strong>Código interno</strong> <SpanBlock>{item.codProduto}</SpanBlock>
              </p>
              <p>
                <strong>Código referência</strong> <SpanBlock>{item.codReferencia}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Depositante</strong> <SpanBlock>{item.parceiro}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Produto</strong> <SpanBlock>{item.descricaoProduto}</SpanBlock>
              </p>
              <p>
                <strong>UN</strong> <SpanBlock>{item.unidade}</SpanBlock>
              </p>
              <p>
                <strong>Total</strong> <SpanBlock>{item.total}</SpanBlock>
              </p>
            </RowLine>

            <CardSecMobile codProduto={item.codProduto} inscricaoEstadual={item.codParceiro} />
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
